module.exports = __webpack_public_path__ + "static/img/servicesBanner3.5aacfd94.png";